import { Select } from "../atoms/Select";

export function SeminarSelect({ seminars = [], value, onChange, disabled }) {
  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  return (
    <Select value={value} onChange={handleChange} disabled={disabled}>
      <option value="">すべて</option>
      {seminars.map((s) => (
        <option key={s.id} value={s.id}>
          {s.label}
        </option>
      ))}
    </Select>
  );
}